
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import * as service from '../../../services/service';

function UpdatePassword() {
    const [state, setState] = useState({ newpassword: '', confirmpassword: '' });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {       
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.newpassword) {
            isValid = false;
            errs[".newpassword"] = "Please enter new password";
        }
        if (!state.confirmpassword) {
            isValid = false;
            errs[".confirmpassword"] = "Please enter confirm password";
        }
        if (state.newpassword !== state.confirmpassword) {
            isValid = false;
            errs[".confirmpassword"] = "New password and Confirm password are not matching.";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.UPDATE_PASSWORD,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        UserId: JSON.parse(sessionStorage.getItem('userData')).userId,
                        Password: state.confirmpassword,  
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,                             
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,                  
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/masters/update');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/masters/office');
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                    setState({ ...state, newpassword: '', confirmpassword: ''});
                });        
            }
            setLoading(false);
        }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Change Password
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">
                                        <MDBox mb={2}>
                                            <MDInput label="New Password" fullWidth value={state.newpassword || ''}
                                                name="newpassword"
                                                onChange={changeHandler}
                                                id="newpassword"
                                                type="password"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".newpassword"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Confirm Password" fullWidth value={state.confirmpassword || ''}
                                                name="confirmpassword"
                                                onChange={changeHandler}
                                                id="confirmpassword"
                                                type="password"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".confirmpassword"]}</div>
                                        </MDBox>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    Update
                                                </MDButton>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default UpdatePassword;